'use strict';

import baseConfig from './base';

let config = {
  parse: {
    appId: 'NGVEpNuOx2oLHIHmybrGXfyEebFkTwRR4tK6Ztyl',
    key: '0RKXe9y8bNHRRnLOJhrEnaBvuzrYXJKtpUg5Ir0E',
    serverURL: 'https://parse.saucey-api.com/parse'
  },
  facebook: {
    appId: '560771857337475'
  },
  stripe: {
    pk: 'pk_live_QprqVhLaTDr2jCkhLG4XxEwg'
  },
  branch: {
    key: 'key_live_icfHx2MTuQRz6knqnYyL6kjevEomXTNh'
  },
  promoCodes: {
    signup: {
      tenOff: 'FIRST10'
    }
  }
};

export default Object.freeze(Object.assign({}, baseConfig, config));



// WEBPACK FOOTER //
// ./client/config/production.js